import React from "react";
import { Show, SimpleShowLayout, Datagrid, NumberField, TextField, ArrayField } from "react-admin";
import { showViewdatagrid } from "../../../../customStyles/ra-custom-styles";

const ShowCatalog = () => {
  return (
    <Show title="Детайли към издание от каталог">
      <SimpleShowLayout>
        <NumberField
          label="Каталожен номер"
          source="catalog_number"
          disabled
        />
        <TextField
          label="Заглавие"
          source="title"
        />
        <TextField
          label="Вид издание"
          source="edition_type"
        />

        <ArrayField
          label="Абонаменти"
          source="subscriptions_prices"
        >
          <Datagrid
            bulkActionButtons={false}
            sx={showViewdatagrid}
          >
            <TextField
              label="Цена в евро."
              source="prices[0].price"
            />
            <TextField
              label="Месеци на абонамента"
              source="month_index"
            />
          </Datagrid>
        </ArrayField>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowCatalog;
